export default "__VITE_PUBLIC_ASSET__7b39fdc1__"